"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiPickType = exports.getCenterOfPallet = exports.getPalletCorners = exports.getXAxisAngle = exports.getPalletDimensions = exports.hasSlipSheet = exports.getSlipSheet = exports.SlipSheetOption = exports.LabelNames = exports.LabelSide = exports.Add3D = exports.Norm = exports.MultiplyScalar = exports.Subtract3D = exports.compareDimensions = exports.to_coord = void 0;
const to_coord = (x) => {
    return {
        x: x[0],
        y: x[1],
        z: x[2],
        θ: x[3],
    };
};
exports.to_coord = to_coord;
function compareDimensions(bd1, bd2) {
    return (bd1.length === bd2.length &&
        bd1.width === bd2.width &&
        bd1.height === bd2.height);
}
exports.compareDimensions = compareDimensions;
function Subtract3D(c1, c2) {
    return { x: c1.x - c2.x, y: c1.y - c2.y, z: c1.z - c2.z };
}
exports.Subtract3D = Subtract3D;
function MultiplyScalar(c1, alpha) {
    return { x: c1.x * alpha, y: c1.y * alpha, z: c1.z * alpha };
}
exports.MultiplyScalar = MultiplyScalar;
function Norm(c) {
    return Math.sqrt(c.x ** 2 + c.y ** 2 + c.z ** 2);
}
exports.Norm = Norm;
function Add3D(c1, c2) {
    return Subtract3D(c1, MultiplyScalar(c2, -1));
}
exports.Add3D = Add3D;
var LabelSide;
(function (LabelSide) {
    LabelSide[LabelSide["None"] = 0] = "None";
    LabelSide[LabelSide["Left"] = 1] = "Left";
    LabelSide[LabelSide["Front"] = 2] = "Front"; /* ie: bottom edge of box in 2d overhead view/layouts editor */
    LabelSide[LabelSide["Right"] = 3] = "Right";
    LabelSide[LabelSide["Back"] = 4] = "Back"; /* ie: top edge of box in 2d overhead view/layouts editor */
})(LabelSide = exports.LabelSide || (exports.LabelSide = {}));
exports.LabelNames = [
    'No Labels',
    'Left',
    'Front',
    'Right',
    'Back',
];
var SlipSheetOption;
(function (SlipSheetOption) {
    SlipSheetOption[SlipSheetOption["None"] = 0] = "None";
    SlipSheetOption[SlipSheetOption["YesExceptTopBottom"] = 1] = "YesExceptTopBottom";
    SlipSheetOption[SlipSheetOption["YesExceptBottom"] = 2] = "YesExceptBottom";
    SlipSheetOption[SlipSheetOption["YesExceptTop"] = 3] = "YesExceptTop";
    SlipSheetOption[SlipSheetOption["Yes"] = 4] = "Yes";
    SlipSheetOption[SlipSheetOption["Custom"] = 5] = "Custom";
})(SlipSheetOption = exports.SlipSheetOption || (exports.SlipSheetOption = {}));
function getSlipSheet(pLayerIndex, pStackLength, allSlipSheets, pConfig) {
    if (!hasSlipSheet(pLayerIndex, pStackLength, pConfig) || !allSlipSheets)
        return undefined;
    // This data structure should be better...
    const ids = pConfig === null || pConfig === void 0 ? void 0 : pConfig.ids;
    if (!!ids && pLayerIndex in ids) {
        const id = ids[pLayerIndex];
        const idx = allSlipSheets.findIndex(ss => ss.id === id);
        if (idx >= 0) {
            return allSlipSheets[idx];
        }
    }
    return undefined;
}
exports.getSlipSheet = getSlipSheet;
function hasSlipSheet(pLayerIndex, pStackLength, pConfig) {
    if (!pConfig)
        return false;
    if (pConfig.exclude && pConfig.exclude[pLayerIndex] !== void 0) {
        return !pConfig.exclude[pLayerIndex];
    }
    switch (pConfig.config) {
        case SlipSheetOption.None:
        case SlipSheetOption.Custom:
            return false;
        case SlipSheetOption.Yes:
            return true;
        case SlipSheetOption.YesExceptTopBottom:
            return pLayerIndex !== 0 && pLayerIndex !== pStackLength;
        case SlipSheetOption.YesExceptBottom:
            return pLayerIndex !== 0;
        case SlipSheetOption.YesExceptTop:
            return pLayerIndex !== pStackLength;
        default:
            return false;
    }
}
exports.hasSlipSheet = hasSlipSheet;
function getPalletDimensions(pallet) {
    return pallet.Dimensions;
}
exports.getPalletDimensions = getPalletDimensions;
function getXAxisAngle(v) {
    return (Math.atan(v.y / v.x) * 180) / Math.PI; // to degrees
}
exports.getXAxisAngle = getXAxisAngle;
function getPalletCorners(pallet, gripper) {
    const angle = (pallet.point.θ * Math.PI) / 180;
    let bl = { ...pallet.point };
    bl.x -= Math.cos(angle) * gripper.x_low + Math.sin(angle) * gripper.y_low;
    bl.y -= Math.sin(angle) * gripper.x_low + Math.cos(angle) * gripper.y_low;
    // ignore angles temporarily.
    let tl = { ...bl };
    tl.y += pallet.Dimensions.length;
    // tl.x += Math.sin(angle) * pallet.Dimensions.length;
    // tl.y += Math.cos(angle) * pallet.Dimensions.length;
    let br = { ...bl };
    br.x += pallet.Dimensions.width;
    // br.x += Math.cos(angle) * pallet.Dimensions.width;
    // br.y += Math.sin(angle) * pallet.Dimensions.width;
    return [tl, bl, br];
}
exports.getPalletCorners = getPalletCorners;
function getCenterOfPallet(p, gripper) {
    let [corner1, corner2, corner3] = getPalletCorners(p, gripper);
    let v1 = Subtract3D(corner1, corner2);
    let v2 = Subtract3D(corner3, corner2);
    return Add3D(Add3D(MultiplyScalar(v1, 0.5), MultiplyScalar(v2, 0.5)), corner2);
}
exports.getCenterOfPallet = getCenterOfPallet;
var MultiPickType;
(function (MultiPickType) {
    MultiPickType[MultiPickType["None"] = 0] = "None";
    MultiPickType[MultiPickType["Double"] = 1] = "Double";
    MultiPickType[MultiPickType["Triple"] = 2] = "Triple";
    // Quadruple = 3,
    // Quintuple = 4,
    // Sextuple = 5,
    // Septuple = 6,
})(MultiPickType = exports.MultiPickType || (exports.MultiPickType = {}));
